"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAssetsAccessToken = void 0;
var verifyToken_1 = require("./verifyToken");
var verifyAssetsAccessToken = function (args) { return (0, verifyToken_1.verifyToken)(args); };
exports.verifyAssetsAccessToken = verifyAssetsAccessToken;
